import React from 'react';
import { Card } from '@abyss/web/ui/Card';

const STEP_LABELS = [
  'Acquired Entity',
  'Upload Data Files',
  'View Tables',
  'View Maps',
];

const UPLOAD_STEP_LABELS = [
  'Acquired Entity',
  'Upload Data Files',
];

interface RouteToolStepperProps {
  currentStep: 1 | 2 | 3 | 4;
  /** When true, renders only the 2 upload steps (step 1 & 2). */
  uploadOnly?: boolean;
}

export const RouteToolStepper = ({ currentStep, uploadOnly }: RouteToolStepperProps) => {
  const labels = uploadOnly ? UPLOAD_STEP_LABELS : STEP_LABELS;

  const getStepStatus = (step: number) => {
    if (step < currentStep) return 'completed';
    if (step === currentStep) return 'current';
    return 'upcoming';
  };

  return (
    <Card
      css={{
        background: '#ffffff',
        border: '1px solid #e3e7ee',
        boxShadow: 'none',
        width: '100%',
      }}
    >
      <Card.Section css={{ width: '100%', padding: '12px 16px' }}>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            {labels.map((_, index) => {
              const stepNumber = index + 1;
              const status = getStepStatus(stepNumber);
              const isCompleted = status === 'completed';
              const isCurrent = status === 'current';
              const isUpcoming = status === 'upcoming';

              return (
                <div
                  key={`step-marker-${stepNumber}`}
                  style={{
                    position: 'relative',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flex: 1,
                    minWidth: 0,
                    cursor: 'default',
                  }}
                >
                  {index < labels.length - 1 && (
                    <div
                      style={{
                        position: 'absolute',
                        top: '14px',
                        left: '50%',
                        right: '-50%',
                        height: '2px',
                        backgroundColor:
                          stepNumber < currentStep ? '#196ecf' : '#d8dde6',
                        zIndex: 0,
                      }}
                    />
                  )}

                  <div
                    style={{
                      position: 'relative',
                      zIndex: 1,
                      width: '30px',
                      height: '30px',
                      borderRadius: '999px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '13px',
                      fontWeight: 700,
                      backgroundColor: isUpcoming ? '#eef1f5' : '#196ecf',
                      color: isUpcoming ? '#9aa5b5' : '#ffffff',
                      border: isCurrent ? '2px solid #196ecf' : '2px solid transparent',
                    }}
                  >
                    {isCompleted ? '✓' : stepNumber}
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ width: '100%', display: 'flex', marginTop: '8px' }}>
            {labels.map((label, index) => {
              const stepNumber = index + 1;
              const status = getStepStatus(stepNumber);
              const isUpcoming = status === 'upcoming';

              return (
                <div
                  key={`step-label-${label}`}
                  style={{
                    flex: 1,
                    textAlign: 'center',
                    fontSize: '11px',
                    lineHeight: 1.2,
                    fontWeight: isUpcoming ? 500 : 700,
                    color: isUpcoming ? '#9aa5b5' : '#196ecf',
                    cursor: 'default',
                    userSelect: 'none',
                  }}
                >
                  {label}
                </div>
              );
            })}
          </div>
        </div>
      </Card.Section>
    </Card>
  );
};
